import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractRefundInvoiceEmailTemplate.Delete.IRequest;
type Response = Api.Core.ContractRefundInvoiceEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ContractRefundInvoiceEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ContractRefundInvoiceEmailTemplate/:id';
export default async function contractRefundInvoiceEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
